
import { SafetyRadarChart } from './charts/SafetyRadarChart';
import { SafetyBarChart } from './charts/SafetyBarChart';
import { SafetyEndpointCards } from './cards/SafetyEndpointCards';
import { endpointBenchmarkData } from '@/data/chemicalSafetyData';

export const ChemicalSafetyBenchmark = () => {
  return (
    <div className="space-y-8">
      {/* Charts Row - Half page width each */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SafetyRadarChart />
        <SafetyBarChart />
      </div>

      {/* Safety Endpoint Cards */}
      <SafetyEndpointCards data={endpointBenchmarkData} />
    </div>
  );
};
